// Libraries.
import svg4everybody from 'svg4everybody'

// Modules.
import { init as lazyLoad } from './modules/lazyload'
import face from './modules/face'
import hamburger from './modules/hamburger'
import instagram from './modules/instagram'
import inview from './modules/inview'
import jump from './modules/jump'
import slider from './modules/slider'
import video from './modules/video'

// Initialize.
function init () {
  svg4everybody()
  lazyLoad()
  face()
  hamburger()
  instagram()
  inview()
  jump()
  slider()
  video()
}

export default init
